import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toHandlers as _toHandlers, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e36b8bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule-msg-box-wrap" }
const _hoisted_2 = { class: "rule-msgbox-title-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "msgbox-body-wrap" }
const _hoisted_5 = { class: "content-header" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "d-calendar" }
const _hoisted_10 = { class: "flex justify-center items-center" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "content-wrap" }
const _hoisted_15 = { class: "mask" }
const _hoisted_16 = { class: "table" }
const _hoisted_17 = { class: "td-content" }
const _hoisted_18 = ["data-game"]
const _hoisted_19 = ["data-game"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { colspan: "8" }
const _hoisted_22 = { class: "mask2" }
const _hoisted_23 = { class: "f1" }
const _hoisted_24 = { class: "f2" }
const _hoisted_25 = { class: "f1" }
const _hoisted_26 = { class: "f2" }
const _hoisted_27 = { class: "f1" }
const _hoisted_28 = { class: "f2" }
const _hoisted_29 = { class: "f1" }
const _hoisted_30 = { class: "f2" }
const _hoisted_31 = { class: "f1" }
const _hoisted_32 = { class: "f2" }
const _hoisted_33 = { class: "f1" }
const _hoisted_34 = { class: "f2" }
const _hoisted_35 = { class: "td-content" }
const _hoisted_36 = ["data-game"]
const _hoisted_37 = ["data-game"]
const _hoisted_38 = { class: "f1" }
const _hoisted_39 = { class: "f1" }
const _hoisted_40 = { class: "f2" }
const _hoisted_41 = {
  key: 0,
  class: "norecord"
}
const _hoisted_42 = {
  key: 0,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_record_pager = _resolveComponent("record-pager")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rule-msg-box-root",
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('setting.betrecord')), 1),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }, [
          _createVNode(_component_icon_x)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('bethistory.totalbet')) + ": " + _toDisplayString(_ctx.totalBetAmount), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('bethistory.totalvalidbets')) + ": " + _toDisplayString(_ctx.totalBetValidAmount), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('bethistory.totalwinorloss')) + ":" + _toDisplayString(_ctx.totalWinResult), 1),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_date_picker, {
              locale: _ctx.lang,
              modelValue: _ctx.dateValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateValue) = $event)),
              "is-dark": "",
              mode: "dateTime",
              color: "gray",
              "is-range": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("input", _mergeProps({
                    value: inputValue.start
                  }, _toHandlers(inputEvents.start), { class: "input-c" }), null, 16, _hoisted_11),
                  _hoisted_12,
                  _createElementVNode("input", _mergeProps({
                    value: inputValue.end
                  }, _toHandlers(inputEvents.end), { class: "input-c" }), null, 16, _hoisted_13)
                ])
              ]),
              _: 1
            }, 8, ["locale", "modelValue"])
          ]),
          _createElementVNode("div", {
            class: "btn-submit",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchDataToaPeriodOfTime && _ctx.fetchDataToaPeriodOfTime(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('common.confirm')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.table')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.gameid')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.gametype')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.bettype')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.gameresult')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.card')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.winorloss')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t('bethistory.date')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataInfoList, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `pc-record-${i.id}`
                  }, [
                    _createElementVNode("td", null, _toDisplayString(i.tableNo), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameNo), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameTypeName), 1),
                    _createElementVNode("td", null, _toDisplayString(i.expand.betContent), 1),
                    _createElementVNode("td", null, _toDisplayString(i.gameResult), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '庄'
                                                        : '龙'
                                                ,
                          class: "handred"
                        }, [
                          (i.expand.bankerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.bankerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.bankerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.bankerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_18),
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '闲'
                                                        : '虎'
                                                ,
                          class: "handblue"
                        }, [
                          (i.expand.playerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.playerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.playerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.playerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_19)
                      ])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass({ win: i.expand.winResult > 0 })
                    }, _toDisplayString(i.expand.winResult), 3),
                    _createElementVNode("td", null, _toDisplayString(i.betTime), 1)
                  ]))
                }), 128)),
                (_ctx.dataInfoList.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.t('bethistory.norecord')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataInfoList, (i) => {
              return (_openBlock(), _createElementBlock("table", {
                class: "m-table",
                key: `m-record-${i.id}`
              }, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.t('bethistory.table')), 1),
                    _createElementVNode("th", _hoisted_24, _toDisplayString(i.tableNo), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.t('bethistory.gameid')), 1),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(i.gameNo), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.t('bethistory.gametype')), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(i.gameTypeName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.t('bethistory.bettype')), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(i.expand.betContent), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.t('bethistory.gameresult')), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(i.gameResult), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.t('bethistory.card')), 1),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '庄'
                                                        : '龙'
                                                ,
                          class: "handred"
                        }, [
                          (i.expand.bankerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.bankerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.bankerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.bankerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.bankerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.bankerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_36),
                        _createElementVNode("div", {
                          "data-game": 
                                                    i.gameTypeNo === 'G002'
                                                        ? '闲'
                                                        : '虎'
                                                ,
                          class: "handblue"
                        }, [
                          (i.expand.playerOne)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`p_${i.expand.playerOne}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerOne
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerTwo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(`p_${i.expand.playerTwo}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerTwo
                                                        )), 3))
                            : _createCommentVNode("", true),
                          (i.expand.playerThree)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(`p_${i.expand.playerThree}`)
                              }, _toDisplayString(_ctx.getCardValue(
                                                            i.expand.playerThree
                                                        )), 3))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_37)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.t('bethistory.winorloss')), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(["f2 red", { win: i.expand.winResult > 0 }])
                    }, _toDisplayString(i.expand.winResult), 3)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.t('bethistory.date')), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(i.betTime), 1)
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.dataInfoList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.t('bethistory.norecord')), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.dataInfoList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(_component_record_pager, {
                  "page-numbers": _ctx.pageNumbers,
                  "pager-info": _ctx.pagerInfo,
                  onGotoPage: _ctx.toPage
                }, null, 8, ["page-numbers", "pager-info", "onGotoPage"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}